import { ProductGtmEvents } from '@/gtm/product/product-gtm-events';
import { DELIVERY_TYPES } from '@/constants/delivery';
import { getDeliveryInterval } from '@/utils/delivery-utils';

export class ProductCardGtmEvents extends ProductGtmEvents {
  viewProductPage({ productCode, productId, price }) {
    return this.gtmEvent({
      eventAction: 'Карточка_ПросмотрСтраницы',
      eventLabel: productCode,
      params: {
        mindbox: {
          sku: productId,
          price,
        },
      },
    });
  }

  chooseSize({ productCode, size }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Размер',
      eventLabel: `${productCode}|${size}`,
    });
  }

  clickDescriptionTab({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Описание_Клик',
      eventLabel: productCode,
    });
  }

  clickDeliveryTab({ productCode, cityName, activeSku }) {
    const eventLabel = [
      productCode,
      cityName,
      activeSku?.size,
      getDeliveryInterval(activeSku?.delivery?.interval),
    ];

    return this.gtmEvent({
      eventAction: 'Карточка_ДоставкаИВозврат_Клик',
      eventLabel: eventLabel.join('|'),
    })
  }

  addToCart({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_ДобавитьВКорзину',
      eventLabel: productCode,
    });
  }

  redirectToCart() {
    return this.gtmEvent({
      eventAction: 'Карточка_ВКорзину',
    });
  }

  chooseColor({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_Цвет',
      eventLabel: productCode,
    });
  }

  scrollPhoto({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_ФотоСкролл',
      eventLabel: productCode,
    });
  }

  addToFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_ДобавитьВИзбранное',
      eventLabel: productCode,
    });
  }

  removeFromFavorite({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_УдалитьИзИзбранного',
      eventLabel: productCode,
    });
  }

  toggleFavorite({ value, productCode }) {
    return value
      ? this.addToFavorite({ productCode })
      : this.removeFromFavorite({ productCode });
  }

  chooseDelivery({ deliveryType, productCode, cityName, size, deliveryInterval, storesCount }) {
    const trackData = {
      eventAction: '',
      eventLabel: [
        productCode,
        cityName,
        size,
      ],
    };

    if (deliveryType === DELIVERY_TYPES.delivery) {
      trackData.eventLabel.push(deliveryInterval);
      trackData.eventAction = 'Карточка_КликДоставитьКурьером';
    } else if (deliveryType === DELIVERY_TYPES.availability) {
      trackData.eventLabel.push(storesCount);
      trackData.eventAction = 'Карточка_КликЗабратьВМагазине';
    } else if (deliveryType === DELIVERY_TYPES.postamat) {
      trackData.eventAction = 'Карточка_КликДоставитьПВЗ';
    } else {
      return;
    }

    return this.gtmEvent({
      ...trackData,
      eventLabel: trackData.eventLabel.join('|'),
    });
  }

  openSizeTable({ productCode }) {
    return this.gtmEvent({
      eventAction: 'Карточка_ТаблицаРазмеров',
      eventLabel: productCode,
    });
  }

  showDelivery({ activeSku, productCode, cityName }) {
    const {
      availabilityCount,
      deliveryInterval,
      isThirdParty,
    } = this.getDeliveryInfo({ activeSku });

    const eventLabel = [
      productCode,
      cityName,
      activeSku?.size,
    ];

    if (deliveryInterval) {
      this.gtmEvent({
        eventAction: 'Карточка_ПоказДоставитьКурьером',
        eventLabel: [...eventLabel, deliveryInterval].join('|'),
      });
    }

    if (availabilityCount) {
      this.gtmEvent({
        eventAction: 'Карточка_ПоказЗабратьВМагазине',
        eventLabel: [...eventLabel, availabilityCount].join('|'),
      });
    }

    if (isThirdParty) {
      this.gtmEvent({
        eventAction: 'Карточка_ПоказДоставитьПВЗ',
        eventLabel: eventLabel.join('|'),
      });
    }
  }
}
